







import Vue from 'vue'
import { Currency } from '@/Domain/Batch/Currency'

export default Vue.extend({
  name: 'LumberJackTableRow',
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    readableStatus (): string {
      return this.item.state
        ? this.$t('tracking.madeirista-status.' + this.item.state).toString()
        : '-'
    },
    readableOffer (): string {
      if (!this.item.ofert) {
        return '-'
      }
      const currency = Currency.fromString(this.item.ofert)
      return currency.pointToString()
    }
  }
})
